import React from 'react';

import { useGetLibraryDictionary } from '../../../hooks/use-get-library-dictionary';
import { ILibraryEventType } from '../../../queries/fragments/libraryEventType';

interface PageComponentImageTagsProps {
  tags?: ILibraryEventType[];
  endDate?: string;
  node_locale: string;
}

export const PageComponentImageTags = ({
  tags,
  endDate,
  node_locale,
}: PageComponentImageTagsProps) => {
  const pastEvent = endDate ? new Date(endDate) < new Date() : false;

  const dictionary = useGetLibraryDictionary(node_locale);
  return tags && tags.length > 0 ? (
    <div className="absolute top-6 left-6 text-neutral-grey-700 lg:top-8 lg:left-8">
      {pastEvent ? (
        <span className="inline-block rounded-md border-2 border-brand-red-2 bg-brand-red-1 px-2.5 py-1.25 text-bodys font-bold text-text-sticker-red">
          {dictionary?.pastEvent}
        </span>
      ) : (
        tags?.map((tag, index) => (
          <span
            key={index}
            className="mr-2 inline-block rounded-md border-2 border-neutral-grey-300 bg-background-primary-light px-2.5 py-1.25 text-bodys font-bold text-text-default last:border-brand-green-2 last:bg-brand-green-1 last:text-text-sticker-green"
          >
            {tag.name}
          </span>
        ))
      )}
    </div>
  ) : (
    <></>
  );
};
